export function toggleActiveGallery(){
  const flag = 'is_active'
  const block = {
    parentClass : '.js_flag_container',
    targetClass : '.js_flag_item',
    navClass    : '.js_flag_tn'
  }

  const parent = document.body.querySelector(block.parentClass)
  if(!parent) return
  const objTargets = parent.querySelectorAll(block.targetClass)
  const objNavs    = parent.querySelectorAll(block.navClass)

  const removeFlag = obj =>{
    for(let i=0;i<obj.length;i++) {
      if (obj[i].classList.contains(flag)) {
        obj[i].classList.remove(flag)
        break
      }
    }
  }

  const addFlag = (obj,id) =>{
    for(let i=0;i<obj.length;i++) {
      if (obj[i].dataset.pid === id) {
        obj[i].classList.add(flag)
        break
      }
    }
  }

  objNavs.forEach(elm =>{
    elm.addEventListener('click',()=>{
      if(!elm.classList.contains(flag)) {
        const targetID = elm.getAttribute('data-target')
        removeFlag(objNavs)
        removeFlag(objTargets)
        addFlag(objTargets,targetID)
        elm.classList.add(flag)
      }
    })
  })
}

